import React from 'react';

export const IsiArrow: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			width="9"
			height="6"
			viewBox="0 0 9 6"
            className={className} 
            fill="currentColor"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.1084 0.494271C4.30858 0.242109 4.69142 0.242109 4.89161 0.494271L8.61942 5.1901C8.87955 5.51778 8.64619 6.00098 8.22781 6.00098L0.772188 6.00098C0.353808 6.00098 0.120451 5.51778 0.380582 5.1901L4.1084 0.494271Z"
			/>
		</svg>
	);
};
